﻿export interface IClcEtmp {
    id: number;
    recipientAlias: string;
    recipientAbo: string;
    cpra: number;
    txpDate: string;
    swap: number;
    cluster: number;
    position: number;
    potentialDonorAlias: string;
    potentialDonorAbo: string;
    donorAlias: string;
    donorAbo: string;
    compPair: string;
    clcPoints: number;
}